import { SolType, SolValidatorDef } from '@sol/components';

export interface CredentialKeyValue {
  readonly classId: string;
  readonly value: string;
}
export class AsmEngagementsType {
  public static readonly credentialKeyValue = SolType.ofObject<CredentialKeyValue>('asm.credentialKeyValue', {
    classId: SolType.string.extend({
      validators: [SolValidatorDef.required.of({ name: 'asm-engagement-request.wizard.custom-class' })],
    }),
    value: SolType.string.extend({
      validators: [SolValidatorDef.required.of({ name: 'asm-engagement-request.wizard.custom-value' })],
    }),
  });
  public static readonly credentialKeyValueEdit = SolType.ofObject<CredentialKeyValue>('asm.credentialKeyValueEdit', {
    classId: SolType.string.extend({
      validators: [SolValidatorDef.required.of({ name: 'asm-engagement-request.wizard.custom-class' })],
    }),
    value: SolType.string,
  });
  public static readonly engagementId = SolType.ofPrimitive<string>(
    'engagementId',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly engagementStatus = SolType.ofPrimitive<string>(
    'engagementStatus',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
  public static readonly subscriptionType = SolType.ofPrimitive<string>(
    'subscriptionType',
    () => '',
    v => v ?? '',
    s => s,
    SolType.string,
  );
}
